import { render, staticRenderFns } from "./TableBtn.vue?vue&type=template&id=618e9679&scoped=true&"
import script from "./TableBtn.vue?vue&type=script&lang=js&"
export * from "./TableBtn.vue?vue&type=script&lang=js&"
import style0 from "./TableBtn.vue?vue&type=style&index=0&id=618e9679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e9679",
  null
  
)

export default component.exports